const Backbone = require('backbone');
const ProductDropModel = require('models/store/client/product/drop');
module.exports = Backbone.Collection.extend({
	model: ProductDropModel,
	url: '/app/api/compare',
	api: 'local'
});
